import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsDownCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M16 8A8 8 0 1 0 0 8a8 8 0 0 0 16 0m-6 .5h2l-4 4l-4-4h2v-4h4z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsDownCircle
